import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { Tag } from 'tags/models/tags';
import { rsimProductDetailsQueries } from '../utils/rsimProductDetailsQueries';

export const useRefreshRSimDetailEntry = (euicc: string) => {
  const queryClient = useQueryClient();

  const refreshTags = useCallback(
    async ({ tags }: { tags: Tag[] }) => {
      const queryKey = rsimProductDetailsQueries.detail({ euicc });
      await queryClient.cancelQueries({ queryKey });

      queryClient.setQueryData(queryKey, (oldData: any) => {
        if (!oldData) {
          return oldData;
        }

        const newData = {
          ...oldData,
          items: oldData?.items.map((rsimProfile: any) => {
            if (rsimProfile.euicc === euicc) {
              return { ...rsimProfile, tags: { items: tags, hasMore: false } };
            }

            return rsimProfile;
          }),
        };

        return newData;
      });
    },
    [queryClient, euicc],
  );

  return {
    refreshTags,
  };
};
